module.exports = __webpack_public_path__ + "static/img/17.6650775.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/17.jpg
// module id = ORmL
// module chunks = 0